const { create } = require("js-md5");

module.exports = {
    //通用
    x_mh:"：",
    x_fh:"；",
    x_dd:" =",
    x_yd:" ≈",
    x_xy:" <",
    x_xyd:" <",
    x_dyd:" >=",
    price_unit:'元',
    minute_unit:'分钟',
    z_unit: '张',
    pc_unit: '件',
    day:'天',
    sp_dh:'多个时用英文逗号[,]隔开',
    wellcom:'欢迎使用管理平台',
    sys_name:'小超聚能',
    cp_name:'广州瀚森营销策划有限公司',
    sys_code:'xcjn888.com 版权所有',
    sys_sn:'粤ICP备2025458984号-1',
    com:'通用',
    copy_ok:'复制成功',

    err_title:"错误",
    warn_title:"警告",
    info_title:"信息",
    success_title:'成功',
    ts_title:"提示",
    ok:'确定',
    chk_ok_p:'请确认',
    insert:'添加',
    insert_ok:'添加成功',
    del_ok:'删除成功',
    op_ok:'操作成功',
    close:'关闭',
    cancel:'取消',
    save:'保存',
    keep_add:'继续添加',
    link_back:'返回',
    not_save:'未保存',
    list:'查询',
    clear:'清空',
    upload:'上传',
    upload_over:'已上传',
    over:'已完成',
    not_upload:'未上传',
    print:'打印',
    del:'删除',
    chk_del:'您确定要删除吗？',
    remove:'移出',
    remove_ok:'移出成功',
    upload_err:'上传失败',
    up_ok:'上传成功',
    down:'下载',
    select_role:'选择角色',
    zdy:'自定义',
    today:'今天',
    yesterday:'昨天',
    curr_week:'本周',
    before_week:'上周',
    curr_month:'本月',
    before_month:'上月',
    next_month:'下月',
    curr_year:'今年',
    before_year:'上年',
    before_month3:'前三月',
    before_month4:'前四月',
    week1:'星期一',
    week2:'星期二',
    week3:'星期三',
    week4:'星期四',
    week5:'星期五',
    week6:'星期六',
    week7:'星期日',
    weeks:['星期一','星期二','星期三','星期四','星期五','星期六','星期日'],
    no_role:'您的账号无权限访问，请联系管理员',
    http_overtime:'本次操作由于网络超时失败,请稍后重试',
    server_error:'服务器连接失败',
    login:'登录',
    scan_login:'扫码登录',
    scan_login_ts:'通过微信/小超聚能App扫码',
    login_xy:'登录视为您已同意第三方账号绑定协议、用户协议、隐私政策、产品服务协议',
    code_login:'账号密码登录',
    mobile_login:'手机号登录',
    input_user_code:'请输入账号',
    input_user_pwd:'请输入密码',
    cn:'中国站',
    coll_dir:'收藏夹',
    coll_time:'收藏时间',
    coll_qty:'收藏数量',
    add_to_coll:'添加到收藏夹',
    coll_err:'收藏失败',
    coll_ok:'收藏成功',
    no_coll:'暂无收藏记录',
    exit: '退出',
    reset_pwd: '重置密码',
    new_pwd:'新密码',
    pwd:'密码',
    chk_pwd:'确认密码',
    user_pwd_err:'两次输入的密码不一致，请重新输入',
    weizhi:'未知',
    refs: '刷新',
    export: '导出excel表',
    mobile:'手机号码',
    birth:'生日',
    user:'用户',
    sex:'性别',
    ewm:'二维码',
    ewm_timeout:'二维码已失效',
    reload_ewm:'刷新二维码',
    ewm_addr:'二维码地址',
    all:'全部',
    add_sub: '添加下级',
    root: "根",
    upd: '修改',
    info: '详情',
    add: '新增',
    code:'编码',
    cname:'名称',
    name:'英文名',
    cdesc:'描述',
    sort:'排序',
    sort2:'序号',
    input:'请输入',
    select:'请选择',
    web_url:'PC端链接',
    wxmp_url:'小程序端链接',
    icon_color:'图标颜色',
    system_group:'系统组',
    cat:'分类',
    icon:'图标',
    s1_flag:'平台可用',
    s2_flag:'区域可用',
    s3_flag:'客户可用',
    add_user:'新增用户',
    add_time:'新增时间',
    upd_user:'修改用户',
    upd_time:'修改时间',
    add_dep:'添加部门',
    select_dep:'选择部门',
    set_dep:'配置部门',
    chk_del_dep:'确定要删除该部门吗？',
    add_role:'添加角色',
    upd_role:'修改角色',
    set_role:'配置角色',
    chk_del_role:'确定要删除该角色吗？',
    set_func:'配置功能',
    select_func:'选择功能',
    op:'操作',
    op_user:'操作人',
    op_date:'操作日期',
    prev_page:'上一页',
    next_page:'下一页',
    one_page_line:'每页行数',
    mod_info:'模板详情',
    mod_cname:'模板名称',
    role_cname:'角色名称',
    clear_com_redis:'清空通用缓存',
    clear_com_setup_redis:'清空配置表(com_setup)缓存',
    org:'组织',
    org_code:'组织编码',
    org_cname:'组织名称',
    code_cname:'编码 名称',
    code_cname2:'账号 姓名',
    content:'内容',
    use_role_cname:'使用角色名称',
    org_mod_cname:'组织类型',
    join_type_cname:'入驻方式',
    get_amt:'获利',
    admin_code:'平台管理员',
    org_admin_code:'组织管理员',
    input_admin_code:'请输入平台管理员账号',
    build_img:'宣传图',
    status:'状态',
    link_cname:'联系人',
    link_mobile:'联系电话',
    cu_cname:'客服人员',
    cu_mobile:'客服电话',
    cu_mobile2:'服务热线',
    cu_time_area:'服务时间',
    addr:'详细地址',
    addr2:'地区',
    select_img:'选择图片',
    crop_img:'裁图',
    scroll_mouse:'鼠标上下滚动可放大缩小',
    lng:'经度',
    lat:'纬度',
    org_imgs:'店内场景图',
    org_imgs_ts:'注释：图片宽高比为1:0.55',
    end_time:'到期时间',
    imgs:'图集',
    logo_img:'形象图',
    set:'设置',
    no_set:'未设置',
    file_size_err:'文件大小超出了限制',
    file_type_err:'文件格式错误',
    search_nodata:'暂无数据',
    insert_user:'添加成员',
    chk_del_user:'您确定要删除该成员吗？',
    upd_dep:'修改部门',
    dep_cname:'部门名称',
    user_code:'账号',
    user_cname:'姓名',
    input_enter:'输入完成后回车查找',
    wx_img_lnk:'微信二维码',
    remove_by_org:'移出本组织',
    app_user:'申请人',
    app_time:'申请时间',
    fb_time:'发布时间',
    rw_status:'审核状态',
    rw_rs:'审核结果',
    app_rw:'提交审核',
    cancel_rw:'继续编辑',
    rw_wait:'审核中',
    edit_wait:'编辑中',
    fee_cat:'付费周期',
    fee:'费用',
    fee_list:'费用清单',
    fee_mod:'费用模板',
    no_fee_amt:'请输入周期所需费用',
    shop:"客户",
    upd_sub_org:'修改下级组织',
    app_sub_org:'申请下级组织',
    upd_app_sub_org:'修改下级组织申请',
    upd_admin_code:'修改平台管理员',
    upd_org_admin_code:'修改组织管理员',
    upd_sub_shop:'修改下级客户',
    high_setup:'高级配置',
    upd_sub_shop_setup:'修改下级高级配置',
    incomplete: '您填写的资料不完整',
    app_org:'申请方',
    app_org2:'组织入驻申请',
    no_rw_remark:'拒绝通过原因',
    input_rw_remark:'请输入拒绝通过原因',
    rw_ok:'审核通过',
    no_rw:'拒绝通过',
    chk_rw:'您确定要审核通过吗？',
    chk_no_rw:'您确定要拒绝通过吗？',
    old_user_code:'原账号',
    new_user_code:'新账号',
    mod2_org:'区域',
    mod3_org:'客户',
    add_unit:'新增计价单位',
    upd_unit:'修改计价单位',
    add_dev_cat1:'新增设备一级分类',
    upd_dev_cat1:'修改设备一级分类',
    add_dev_cat2:'新增设备二级分类',
    upd_dev_cat2:'修改设备二级分类',
    cat_1:'一级分类',
    cat_2:'二级分类',
    type:'类型',
    buy_amt:'累计消费金额',
    ratio:'折扣',
    not_0: "0不启用",
    date_0: "0无期限",
    wait_not:'暂无',
    up_goods:'上架',
    down_goods:'下架',
    up_status:'启用',
    down_status:'停用',
    zhe:'折',
    level:'等级',
    num: "整数",
    change:'调整',
    add_qty:'增加数量',
    del_qty:'减少数量',
    change_remark:'调整原因',
    member_type:'会员类型',
    member_code:'会员编码',
    add_member_type:'新增会员类型',
    upd_member_type:'修改会员类型',
    wx_app_id:'微信公众号APPID',
    wx_app_secret:'微信公众号Secret',
    wx_miniapp_id:'微信小程序APPID',
    wx_miniapp_secret:'微信小程序Secret',
    wx_mch_id:'微信商户号',
    wx_key:'微信支付秘钥',
    copy:'复制',
    copy_url_ts:'（可复制二维码地址自行制作二维码样式）',
    new_price:'售价',
    amt:'金额',
    pkg_amt:'套餐金额',
    set_null:"置空",
    loading:'加载中',
    sum:'合计',
    tot:'汇总',
    pay_ok_time:'支付时间',
    pay_amt_ex:'支付手续费',
    rw_user:'审核人员',
    rw_user2:'审批人员',
    rw_time:'审核时间',
    order_user:'下单人员',
    order_time:'下单时间',
    order_fr:'下单方',
    print_user:'打印用户',
    print_time:'打印时间',
    prov:'省份',
    city:'城市',
    area:'区域',
    no_limit:'不限',
    no_limit_date:'不限时',
    use_time:'使用时间',
    date:'日期',
    order_member:'下单会员',
    coupon:'优惠券',
    order_err_cdesc:'下单失败原因',
    pay_cat:'支付方式',
    pay_status:'支付状态',
    df_flag:'默认',
    history:'历史',
    from:'来源',
    last_login_time:'最后上线时间',
    last_login_addr:'最后上线地址',
    in_time:'入会时间',
    member:'会员',
    at_member:'推广会员',
    dtl:'明细',
    mv_amt:'移动金额',
    limit_file:'限格式',
    p_org:'上级',
    auto:'自动',
    auth_flag:'需授权',
    day_qty:'有效天数',
    so_setup:'营销配置',
    pticket:'奖票',
    pticket_ratio:'奖票兑换比例',
    min_member_type:'最低会员级别',
    coupont_cname:'发布主题',
    coupont_timeout_date:'领券截止日期',
    recv_qty:'已领数量',
    use_limit_amt:'满额',
    use_limit_day:'券有效期',
    coupont_tot_qty:'总张数',
    coupont_amt:'面值',
    coupon_code:'券号',
    recv_member:'领取会员',
    recv_time:'领取时间',
    tot_qty:'总数量',
    bal_qty:'剩余数量',
    add_coupont:'发布优惠券',
    upd_coupont:'优惠券详情',
    app_coupont:'审核发布的优惠券',
    unit:'计价单位',
    bar_code:'条码',
    goods_mod: '型号',
    spec:'规格',
    tos:'适应范围',
};



// WEBPACK FOOTER //
// ./src/utils/lang/zh-CN.js